import React, {Component} from 'react';
import {getLocalizedStrings} from 'locale/i18n';
import './Footnotes.scss';
import {connect} from "react-redux";

class Footnotes extends Component {
  render () {
    const strings = getLocalizedStrings(this.props.app.config.lang);
    return (
      <div className='footnotes'>
        <p className='footnote'>{strings['fundu-note-1']}</p>
        <p className='footnote'>{strings['fundu-note-2'] + ' '}<a className='footnote-link' target='_blank' rel='noopener noreferrer' href={strings['fundu-note-3-link']}>{strings['fundu-note-3']}</a></p>
      </div>
    );
  }
}
export default connect(state => ({app: state.app}))(Footnotes);
